/** @format */

export const MAX_PROJECT_BOX_WIDTH = 230;
export const MAX_PROJECT_TEXT_WIDTH = 420;
